import { Notification } from '@models/notifications/Notification.interface';
import { NotificationToastConfig } from '@models/notifications/NotificationToastConfig.interface';
import { NotificationType } from '../types/notification.type';

/**
 * Defines toast style depending on method name
 * @param target
 * @param {NotificationType} propertyKey
 * @param {PropertyDescriptor} descriptor
 * @returns {{value: ((...args: any[]) => any)}}
 * @constructor
 */
export function SetToastType(target: any, propertyKey: NotificationType, descriptor: PropertyDescriptor) {
  return {
    value: function (...args: any[]) {
      let notificationConfig: NotificationToastConfig | undefined = (args[0] as Notification).config;
      if (notificationConfig) {
        notificationConfig = {
          ...(args[0] as Notification).config,
          type: propertyKey
        } as NotificationToastConfig;
      }
      return descriptor.value.apply(this, args);
    }
  };
}
